/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import moment from 'moment'
import InputBox from '../../components/InputBox'
import TextArea from '../../components/TextArea'
import CustomDatePicker from '../../components/DatePicker'
import ImageUpload from '../../components/ImageUpload'
import DropdownWithoutSearch from '../../components/DropdownWithoutSearch'
import ErrorMessage from '../../components/ErrorMessage'
import TopHeader from '../../components/TopHeader'
import { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GlobalContext from '../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { useAddDeviceTemplateMutation, useEditDeviceTemplateMutation, useViewDeviceTemplateQuery ,useLazyViewDeviceTemplateQuery} from '../../features/deviceTemplateSlice'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import Loader from '../../components/Loader'
import { handleIsAPICall } from '../../redux/commonSlice'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import S3UploadHook from '../../CommonMethods/S3UploadHook'
import { CDN } from '../../config'
import { convertEpochToDateFormat } from "../../CommonMethods/DateConversion"
import Dropdown from '../../components/Dropdown'
import { useGetDeviceManufactureQuery } from '../../features/deviceSlice'
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import { broadcastForcedLogout } from '../../CommonMethods/authSession'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
    

export default function AddDeviceTemplate({ edit }) {
    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, isSideBar ,editSocket ,sendMessageToStartEditing,sendMessageToStopEditing} = useContext(GlobalContext)
    const dispatch = useDispatch()
    const { id } = useParams()
    const location = useLocation()
    const mainKey = 'device-template-images'
    const [skip, setSkip] = useState(true)
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const { data, isFetching, status } = useViewDeviceTemplateQuery(id, { skip: skip })
    const [addDeviceTemplate] = useAddDeviceTemplateMutation()
    const [editDeviceTemplate] = useEditDeviceTemplateMutation()
    const { data: manufactureData, isFetching: manufactureFetching } = useGetDeviceManufactureQuery();
    const reading_types = ['Blood Glucose', 'Blood Pressure', 'SPO2', 'Weight', 'Pulse', 'Temperature']
    const imageTypes = ['image/png', 'image/jpeg', 'image/jpg']
    const [deviceTemplateDetails, setDeviceTemplateDetails] = useState({
        "template_name": "",
        "reading_type": [],
        "manufacturer_name": "",
        "model": "",
        "warranty_period": "",
        "purchase_date": "",
        "service_provider": "",
        "service_period": "",
        "service_activation_date": "",
        "original_location": "",
        "description": "",
        "image_url": ""

    })
    const [dataloading,setDataLoading] = useState(true)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [trigger,result] = useLazyViewDeviceTemplateQuery()
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const [nextTarget, setNextTarget] = useState('');
    const [formatError, setformatError] = useState('')
    const [emptyField, setEmptyField] = useState(false)

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)

    const [statusToggle, setStatusToggle] = useState(false)
    const [emptyArea, setEmptyArea] = useState(false);
    const [usernameError, setUsernameError] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const [uploadImageLoader, setUpoadImageLoader] = useState(false)
    const isFromEdit = location.state?.[1] || false; 
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
   
    useEffect(() => {
        if (edit) {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-edit-device-template');
            } else {
                setQueryParamsadmin('type=admin-edit-device-tempates');
            }
        } else {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-add-device-template');
            } else {
                setQueryParamsadmin('type=admin-add-device-templates');
            }
        }
    }, [userType,edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);




    /**
    * The function `handleSelectAll` updates the `reading_type` property of `deviceTemplateDetails`
    * based on whether `selectAllChecked` is true or false.
    */
    const handleSelectAll = (selectAllChecked) => {
        setIsDisableCancel(false)
        setDeviceTemplateDetails((prev) => {
            if (selectAllChecked) {
                // Add all elements to the array
                return {
                    ...prev,
                    reading_type: [...reading_types]
                };
            } else {
                // Remove all elements from the array
                return {
                    ...prev,
                    reading_type: []
                };
            }
        });
    }

    /**
    * The handleClear function clears the reading_type property in the deviceTemplateDetails state.
    */
    const handleClear = () => {
        setDeviceTemplateDetails((prv) => ({
            ...prv,
            "reading_type": [],
        }));
    }


    /**
     * The function `handleReadingTypeSelect` updates the `reading_type` property in the
    * `deviceTemplateDetails` state based on the selected item.
    */
    const handleReadingTypeSelect = (selectedItem) => {
        setIsDisableCancel(false)
        setDeviceTemplateDetails((prev) => {
            // Check if the selected item is already in the array
            const isItemSelected = prev.reading_type.includes(selectedItem);
            // If the item is selected, remove it; otherwise, add it
            const updatedReadingType = isItemSelected
                ? prev.reading_type.filter(item => item !== selectedItem)
                : [...prev.reading_type, selectedItem];
            return {
                ...prev,
                reading_type: updatedReadingType
            };
        });
    }

    /**
     * The function `handleSelectDate` updates the `purchase_date` or `service_activation_date` in the
     * `DeviceTemplateDetails` state based on the provided `id` and `dateString`.
     */
    function handleSelectDate(id, date, dateString, termkey) {
        setIsDisableCancel(false)
        if (id === "purchase_date") {
            setDeviceTemplateDetails((prv) => ({
                ...prv,
                purchase_date: moment(dateString).format('MM-DD-YYYY'),
            }));
        }
        else {
            setDeviceTemplateDetails((prv) => ({
                ...prv,
                service_activation_date: moment(dateString).format('MM-DD-YYYY'),
            }));
        }
    }


    /**
    * The function `handleOnChangeUserDetails` updates a specific field in the `deviceTemplateDetails`
    * state based on the provided `id` and `option` parameters.
    */
    function handleOnChangeUserDetails(id, option) {
        const fieldToUpdate = {
            template_name: "template_name",
            manufacturer_name: "manufacturer_name",
            model: "model",
            warranty_period: "warranty_period",
            purchase_date: "purchase_date",
            service_provider: "service_provider",
            service_period: "service_period",
            service_activation_date: "service_activation_date",
            original_location: "original_location",
            image_url: "image_url",
            description: "description",
        }[id];

        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true

        if (id === "warranty_period" || id==="service_period") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setDeviceDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }

        if (fieldToUpdate) {
            setIsDisableCancel(false)
            setDeviceTemplateDetails((prev) => ({
                ...prev,
                [fieldToUpdate]: option,
            }));
        }
    }

    /**
     * The function `handleUploadChange` handles the change event when a file is uploaded, checks if
     * the file meets the required format and size, and uploads the file to an S3 bucket if it passes
     * the checks.
     * @returns The function `handleUploadChange` does not have a return statement, so it does not
     * explicitly return anything.
     */
    async function handleUploadChange(e) {
        setUpoadImageLoader(true);
        setformatError('')
        const id = e.target.id
        const selectedFile = e.target.files[0];
        if (e.target.files) {
            if (!imageTypes.includes(e.target.files[0].type)) {
                setformatError(e.target.id);
                e.target.value = null
                setToastErrorMessage('The uploaded file does not meet the required file format or size. Please try again')
                setUpoadImageLoader(false)
                return;
            }
            if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
                setformatError(e.target.id);
                e.target.value = null
                setToastErrorMessage('Image must be in PNG/JPEG format Image size cannot exceed 10 MB')
                setUpoadImageLoader(false)
                return;
            }
            const file = e.target.files[0];
            let url = '';
            if (file.name && file.type) {
                setIsDisableCancel(false)
                url = await S3UploadHook(file, mainKey);
                setDeviceTemplateDetails((prv) => ({
                    ...prv,
                    [id]: url
                }))
                setUpoadImageLoader(false);
            }
        }
    }

    /**
    * The function `handleRemoveImage` updates the `image_url` property of `deviceTemplateDetails` to an
    * empty string.
    */
    const handleRemoveImage = () => {
        setDeviceTemplateDetails((prv) => ({
            ...prv,
            image_url: ''
        }))
    }


    function formatReadingTypes(readingTypes) {
        return readingTypes.map(type => type.replace(/\s+/g, '-').toLowerCase());
    }

    /**
    * The function `handleAddDeviceTemplate` is used to add or edit a device template and display
    * appropriate toast messages based on the API response.
    */
    const handleAddDeviceTemplate = async () => {
        setLoading(true)
        try {
            setLoading(true)
            let body = {
                "template_name": deviceTemplateDetails.template_name,
                "reading_type": formatReadingTypes(deviceTemplateDetails.reading_type),
                "manufacturer_name": deviceTemplateDetails.manufacturer_name,
                "model": deviceTemplateDetails.model,
                "warranty_period": deviceTemplateDetails.warranty_period,
                "purchase_date": deviceTemplateDetails.purchase_date !== "" ? moment(deviceTemplateDetails.purchase_date).format('YYYY-MM-DD') : '',
                "service_provider": deviceTemplateDetails.service_provider,
                "service_period": deviceTemplateDetails.service_period,
                "service_activation_date": deviceTemplateDetails.service_activation_date !== "" ? moment(deviceTemplateDetails.service_activation_date).format('YYYY-MM-DD') : '',
                "original_location": deviceTemplateDetails.original_location,
                "description": deviceTemplateDetails.description,
                "image_url": deviceTemplateDetails.image_url,
            }
            // edit provider
            if (edit) {
                const editRes = await editDeviceTemplate({ id, body })
                //dispatch(handleIsAPICall(true))
                if (editRes?.error?.data?.message) {
                    setToastErrorMessage(editRes?.error?.data?.message)
                    setLoading(false)
                }
                else {
                    navigate(`/manage-device-templates/${id}`)
                    setToastmessage('Device template updated successfully');
                    setLoading(false)
                }
            }
            else {
                const addRes = await addDeviceTemplate(body)
                //dispatch(handleIsAPICall(true))
                if (addRes?.error?.data?.message) {
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                }
                else {
                    navigate(`/manage-device-templates/${addRes?.data?.template_id}`)
                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            //dispatch(handleIsAPICall(true))
            setToastErrorMessage(error.message)
        }
    }

    /* The above code is using the `useEffect` hook in React to perform a side effect. It is checking if
    the `edit` variable is true, and if it is, it sets the `skip` variable to false. The `useEffect`
    hook is triggered whenever the `edit` variable changes. */
    useEffect(()=>{
        if(edit){
            setSkip(false) 
        } 
        if(id){
            trigger(id)      
        }       
    },[edit,id])

  
    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    /* The above code is a useEffect hook in JavaScript React. It is triggered when the "data" variable
    changes. */
    useEffect(() => {
        if(result!==undefined&&result?.data?.template_id!==undefined){
            dispatch(handleTargetUserEditId(result?.data?.template_id))
            if(edit&&!messageSent&&editSocket){
               
                sendMessageToStartEditing(result?.data?.template_id)
            
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-device-templates')
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this device template`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            setDeviceTemplateDetails((prev) => ({
                ...prev,
                "template_name": result?.data.template_name,
                "reading_type": result?.data.reading_type,
                "manufacturer_name": result?.data.manufacturer_name,
                "model": result?.data.model,
                "warranty_period": result?.data.warranty_period,
                "purchase_date": result?.data.purchase_date,
                "service_provider": result?.data.service_provider,
                "service_period": result?.data.service_period,
                "service_activation_date": result?.data.service_activation_date,
                "original_location": result?.data.original_location,
                "description": result?.data.description,
                "image_url": result?.data.image_url,
            }))
            setStatusToggle(result?.data?.status === "inactive" ? false : true)
            setSkip(true)
        }
        return(()=>{
          
            if(((location.state===null || location.state==='')&&result?.data?.template_id!==undefined)){
                
                sendMessageToStopEditing(result?.data?.template_id)
            }  
        })
    }, [result]);


    const handleConformationClick = () => {
        setEmptyArea(false)
        setConfirmationState(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    /**
    * The handleSubmit function checks if any mandatory fields are empty and displays an error message
    * if they are, otherwise it sets the confirmation state to true.
    * @returns The function `handleSubmit` returns nothing.
    */
    const handleSubmit = () => {
        const hasEmptyFields = () => {
            let isFieldsEmpty = false
            if (deviceTemplateDetails.template_name.trim() === "") {
                isFieldsEmpty = true
            }
            return isFieldsEmpty
        };
        if (hasEmptyFields()) {
            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        } else {
            setConfirmationState(true)
        }
    }

    const handleCancel = () => {
        setDeviceTemplateDetails('');
        if (nextTarget === 'view') {
            navigate(`/manage-device-templates/${id}`);
        } else {
            navigate('/manage-device-templates');
        }
        // navigate('/manage-device-templates');
    }

    /**
    * The function `handleCancelBottom` checks if all values in `deviceTemplateDetails` are empty and
    * either navigates to a different page or sets `confirmationStateCancel` to true.
    */
    const handleCancelBottom = () => {   
        const stateToPass = Array.isArray(location.state) ? '' : location.state;


        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-device-templates/${id}`);
        } else if (isDisableCancel) {
            navigate('/manage-device-templates',{ state: stateToPass });
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }    
        // const values = Object.values(deviceTemplateDetails);
        // const isEmpty = values.every(value => !value);
        // if(isDisableCancel){
        //     navigate('/manage-device-templates'); 
        // }
        // if (!isEmpty) {
        //     setConfirmationStateCancel(true);  
        // } else {     
        //     navigate('/manage-device-templates');
        // } 
    };
    useEffect(()=>{
        return(()=>{
       
            if(location?.state!==null||location?.state!==''){
         
                sendMessageToStopEditing()
            }
        })
       
    },[])
    const creationTimestamp=convertEpochToDateFormat(data?.created_at,dateformat)
    const updationTimestamp = convertEpochToDateFormat(data?.updated_at, dateformat);
 


    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full'>
                <TopHeader title={`Manage Device Template`} />
                {((edit && isFetching && status !== "fulfilled") || loadingStatus) ? <CustomOverLay Active text="Loading Device Templates..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : <>
                    <div className='bg-white rounded-lg py-[12px] pl-[30px] pr-[10px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='pr-7'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-device-templates" state={location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Device Templates</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                                            <Link to={`/manage-device-templates/${location.state?.[2]}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Device Template</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`${edit ? 'Edit ' : 'Create '}Device Template`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    {isFromEdit===true ?
                                        <div onClick={handleCancelBottom} className='items-center cursor-pointer min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Device Template</span>
                                        </div> 
                                        :    
                                        <div onClick={handleCancelBottom} state={location.state} className='flex  cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </div>
                                    }
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        {`${edit ? 'Edit ' : 'Create '}Device Template`}
                                    </h1>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className={`pr-5 h-customh16  overflow-x-auto lg:overflow-x-hidden scrollbar_gray overflow-y-auto bg-white`}>
                                    <div className="border  border-[#C5C9DA] rounded-sm xl:px-[58px] lg:px-[20px] py-[44px]  mb-4 flex w-full">
                                        <div className='w-[30%] mr-[24px] relative'>
                                            {deviceTemplateDetails.image_url === '' ? (
                                                <div className='absolute left-3 right-3 top-0'>
                                                    {uploadImageLoader ? (
                                                        <div className=' h-[250px] relative  border-2 border-dashed  border-[#972E4C] px-4 xl rounded-lg mt-3 '>
                                                            <div className='flex justify-center items-center mt-[90px]'>
                                                        
                                                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  spin-animation"></div>
                                                        
                                                         
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <ImageUpload
                                                            uploadImageLoader={uploadImageLoader}
                                                            handleUploadChange={handleUploadChange}
                                                            id='image_url'
                                                            mainkey={'device_template'}
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                
                                                  
                                                <div>
                                                    {deviceTemplateDetails.image_url !== '' && (
                                                        <div className="relative w-full border-2 border-dashed  border-[#972E4C] px-4 xl:py-8 py-4 rounded-lg mt-3">
                                                            <img src={`${CDN}${deviceTemplateDetails.image_url}`} className="tp:w-[600px] w-[445px] h-[200px]  rounded-lg" alt="img" />
                                                            <img
                                                                src="/images/cross.svg"
                                                                alt="icon"
                                                                className="absolute top-[40px] right-[20px] w-7 h-7 bg-[#C81720] rounded-full cursor-pointer"
                                                                onClick={() => handleRemoveImage()}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                    
                                                
                                            )}
                                        </div>
                                        <div className='flex flex-wrap overflow-auto h-[500px] pb-10  scrollbar_purple  items-center -mx-[18px] w-[70%]'>
                                            <div className={`w-1/2 px-[18px] mb-[32px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Template Name*"}
                                                        placeholder={"Enter template name"}
                                                        id={"template_name"}
                                                        htmlFor={"Provider_Username"}
                                                        value={deviceTemplateDetails.template_name}
                                                        data_testid={"template_name"}
                                                        usernameError={usernameError}
                                                        emptyField={emptyField && deviceTemplateDetails?.template_name?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={50}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <DropdownWithoutSearch
                                                        label={"Reading Type"}
                                                        id={`reading_type`}
                                                        placeholder={`${deviceTemplateDetails.reading_type.length === 0 ? "Select reading type" : `${deviceTemplateDetails.reading_type.length} selected`}`}
                                                        disabled={false}
                                                        // index={i}
                                                        // value={newOrgFields[index].organizations}
                                                        options={reading_types}
                                                        handleReadingTypeSelect={handleReadingTypeSelect}
                                                        deviceTemplateDetails={deviceTemplateDetails}
                                                        handleSelectAll={handleSelectAll}
                                                        handleClear={handleClear}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[35px]'>
                                                <div className='w-full'>
                                                    <Dropdown
                                                        label={"Device Manufacturer"}
                                                        id={"manufacturer_name"}
                                                        device_manufacture={true}
                                                        placeholder={deviceTemplateDetails.manufacturer_name?.length > 0 ? '' : 'Select device manufacturer'}
                                                        data_testid={"manufacturer_name"}
                                                        value={deviceTemplateDetails?.manufacturer_name}
                                                        options={manufactureData?.data?.map(item => item.manufacturer_name)}
                                                        emptyField={''}
                                                        handleOnChangeInput={handleOnChangeUserDetails}                                                        
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Model"}
                                                        placeholder={"Enter model"}
                                                        id={"model"}
                                                        data_testid={"model"}
                                                        htmlFor={"model"}
                                                        value={deviceTemplateDetails.model}
                                                        // emptyField={emptyField && deviceTemplateDetails?.model?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={30}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-[60%]'>
                                                    <InputBox
                                                        label={"Warranty Period (Months)"}
                                                        placeholder={"Enter warranty period"}
                                                        id={"warranty_period"}
                                                        data_testid={"warranty_period"}
                                                        htmlFor={"warranty_period"}
                                                        value={deviceTemplateDetails.warranty_period}
                                                        // emptyField={emptyField && deviceTemplateDetails?.warranty_period?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={50}
                                                    />
                                                </div>
                                            </div>
                                            <div className='xl:w-1/3 w-1/2 px-[18px] mb-[32px]'>
                                                <CustomDatePicker
                                                    id={"purchase_date"}
                                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                                    format="MM/DD/YYYY"
                                                    // state={filterValues}
                                                    placeholder={"Select Date"}
                                                    label={"Purchase Date"}
                                                    termkey={deviceTemplateDetails.purchase_date}
                                                    handleSelect={handleSelectDate}
                                                    imageClass={true}
                                                // setdateError={setdateError}
                                                />
                                                
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Service Provider"}
                                                        placeholder={"Enter service provider"}
                                                        id={"service_provider"}
                                                        data_testid={"service_provider"}
                                                        htmlFor={"service_provider"}
                                                        value={deviceTemplateDetails.service_provider}
                                                        // emptyField={emptyField && deviceTemplateDetails?.service_provider?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={50}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-[60%]'>
                                                    <InputBox
                                                        label={"Service Period (Months)"}
                                                        placeholder={"Enter service period"}
                                                        id={"service_period"}
                                                        data_testid={"service_period"}
                                                        htmlFor={"service_period"}
                                                        value={deviceTemplateDetails.service_period}
                                                        // emptyField={emptyField && deviceTemplateDetails?.service_period?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={50}
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className='xl:w-1/3 w-1/2 px-[18px] mb-[32px]'>
                                                <CustomDatePicker
                                                    id={"service_activation_date"}
                                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                                    format="MM/DD/YYYY"
                                                    // state={filterValues}
                                                    placeholder={"Select Date"}
                                                    label={"Service Activation Date"}
                                                    termkey={deviceTemplateDetails.service_activation_date}
                                                    handleSelect={handleSelectDate}
                                                    imageClass={true}
                                                    // setdateError={setdateError}
                                                />
                                            </div>

                                        
                                            
                                            

                                            
                                            <div className='w-1/2 ml-auto px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Original Location"}
                                                        placeholder={"Enter original location"}
                                                        id={"original_location"}
                                                        data_testid={"original_location"}
                                                        htmlFor={"original_location"}
                                                        value={deviceTemplateDetails.original_location}
                                                        // emptyField={emptyField && deviceTemplateDetails?.original_location?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={50}
                                                    />
                                                </div>
                                            </div>
                                            {edit && 
                                                <>
                                                    <div className='w-1/2 px-[18px] mb-[32px]'>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Template ID"}
                                                                placeholder={"Enter service provider"}
                                                                id={"service_provider"}
                                                                data_testid={"service_provider"}
                                                                htmlFor={"service_provider"}
                                                                value={data && data?.template_id}
                                                                // emptyField={emptyField && deviceTemplateDetails?.service_provider?.trim() === ""}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                                maxLength={50}
                                                                disabled={edit === true ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 px-[18px] mb-[32px]'>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Template Creator"}
                                                                placeholder={"Enter service provider"}
                                                                id={"service_provider"}
                                                                data_testid={"service_provider"}
                                                                htmlFor={"service_provider"}
                                                                value={data && data.template_creator}
                                                                // emptyField={emptyField && deviceTemplateDetails?.service_provider?.trim() === ""}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                                maxLength={50}
                                                                disabled={edit === true ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 px-[18px] mb-[32px]'>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Creation Timestamp"}
                                                                placeholder={"Enter service provider"}
                                                                id={"service_provider"}
                                                                data_testid={"service_provider"}
                                                                htmlFor={"service_provider"}
                                                                value={creationTimestamp ? creationTimestamp : '-'}
                                                                // emptyField={emptyField && deviceTemplateDetails?.service_provider?.trim() === ""}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                                maxLength={50}
                                                                disabled={edit === true ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 px-[18px] mb-[32px]'>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Last Modified Timestamp"}
                                                                placeholder={"Enter service provider"}
                                                                id={"service_provider"}
                                                                data_testid={"service_provider"}
                                                                htmlFor={"service_provider"}
                                                                value={updationTimestamp ? updationTimestamp : '-'}
                                                                // emptyField={emptyField && deviceTemplateDetails?.service_provider?.trim() === ""}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                                maxLength={50}
                                                                disabled={edit === true ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                                
                                            }
                                            <div className='w-full px-[18px] '>
                                                <div className='w-full h-[130px] '>
                                                    <TextArea
                                                        label={"Description"}
                                                        placeholder={"Enter description here..."}
                                                        id={"description"}
                                                        data_testid={"description"}
                                                        htmlFor={"description"}
                                                        value={deviceTemplateDetails.description}
                                                        // emptyField={emptyField && deviceTemplateDetails?.description?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={300}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-end pr-5'>
                                    <div>
                                        <button type='button'
                                            id="cancel"
                                            onClick={() => handleCancelBottom()}
                                            className={`px-4 py-2.5 mr-5 text-lg font-semibold text-[#972E4C] border border-[#972E4C]  rounded-[16px] mt-2.5 w-[148px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff]`}>
                                            {"Cancel"}
                                        </button>
                                        <button type='button'
                                            id="update"
                                            data-testid="add-provider-btn"
                                            onClick={handleSubmit}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                              bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                            {`${edit ? 'Update' : 'Submit'}`}

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {confirmationState &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleAddDeviceTemplate}
                                handleClose={handleConformationClick}
                                data-testid="confirm-btn"
                                disabled={loading}
                                tittle={`${edit ? 'Update' : 'Create Device Template'}`}
                                message={`Are you sure you want to  ${edit ? 'Update' : 'create'} this device template?`}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {confirmationStateCancel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                buttonName={true && 'Yes'}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )
}
